"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchCallCampaignService = void 0;
const utils_1 = require("@hc-frontend/utils");
const config_1 = require("../config");
/**
 * Fetch a call campaign from sem content. @See https://github.com/healthcarecom/sem-content#get-campaign-of-calls
 *
 * @public
 *
 * @param {ICallCampaignPayload} payload - The payload to send to sem content endpoint
 *
 * @returns {ICallCampaignResponse | null} - The response from sem content endpoint
 *
 * @example
 *
 * ```ts
 * const payload = { ... }
 * const phone = await fetchCallCampaignService(payload);
 * ```
 */
async function fetchCallCampaignService(payload) {
    const { parsedBody } = await (0, utils_1.fetchJSON)(`${(0, config_1.semContentURI)()}/call/campaign`, {
        body: payload,
    });
    return (parsedBody === null || parsedBody === void 0 ? void 0 : parsedBody.data) ? parsedBody : null;
}
exports.fetchCallCampaignService = fetchCallCampaignService;
//# sourceMappingURL=fetch-call-campaign-service.js.map